import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as Mat4Func from './functions/Mat4Func.js';
export var Mat4 = /*#__PURE__*/function (_Array) {
  _inherits(Mat4, _Array);

  var _super = _createSuper(Mat4);

  function Mat4() {
    var _this;

    var m00 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var m01 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var m02 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var m03 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var m10 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var m11 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var m12 = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var m13 = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    var m20 = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
    var m21 = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : 0;
    var m22 = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : 1;
    var m23 = arguments.length > 11 && arguments[11] !== undefined ? arguments[11] : 0;
    var m30 = arguments.length > 12 && arguments[12] !== undefined ? arguments[12] : 0;
    var m31 = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : 0;
    var m32 = arguments.length > 14 && arguments[14] !== undefined ? arguments[14] : 0;
    var m33 = arguments.length > 15 && arguments[15] !== undefined ? arguments[15] : 1;

    _classCallCheck(this, Mat4);

    _this = _super.call(this, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Mat4, [{
    key: "x",
    get: function get() {
      return this[12];
    },
    set: function set(v) {
      this[12] = v;
    }
  }, {
    key: "y",
    get: function get() {
      return this[13];
    },
    set: function set(v) {
      this[13] = v;
    }
  }, {
    key: "z",
    get: function get() {
      return this[14];
    },
    set: function set(v) {
      this[14] = v;
    }
  }, {
    key: "w",
    get: function get() {
      return this[15];
    },
    set: function set(v) {
      this[15] = v;
    }
  }, {
    key: "set",
    value: function set(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
      if (m00.length) return this.copy(m00);
      Mat4Func.set(this, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33);
      return this;
    }
  }, {
    key: "translate",
    value: function translate(v) {
      var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      Mat4Func.translate(this, m, v);
      return this;
    }
  }, {
    key: "rotate",
    value: function rotate(v, axis) {
      var m = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
      Mat4Func.rotate(out, m, v, axis);
      return this;
    }
  }, {
    key: "scale",
    value: function scale(v) {
      var m = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
      Mat4Func.scale(this, m, typeof v === "number" ? [v, v, v] : v);
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(ma, mb) {
      if (mb) {
        Mat4Func.multiply(this, ma, mb);
      } else {
        Mat4Func.multiply(this, this, ma);
      }

      return this;
    }
  }, {
    key: "identity",
    value: function identity() {
      Mat4Func.identity(this);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(m) {
      Mat4Func.copy(this, m);
      return this;
    }
  }, {
    key: "fromPerspective",
    value: function fromPerspective() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          fov = _ref.fov,
          aspect = _ref.aspect,
          near = _ref.near,
          far = _ref.far;

      Mat4Func.perspective(this, fov, aspect, near, far);
      return this;
    }
  }, {
    key: "fromOrthogonal",
    value: function fromOrthogonal(_ref2) {
      var left = _ref2.left,
          right = _ref2.right,
          bottom = _ref2.bottom,
          top = _ref2.top,
          near = _ref2.near,
          far = _ref2.far;
      Mat4Func.ortho(this, left, right, bottom, top, near, far);
      return this;
    }
  }, {
    key: "fromQuaternion",
    value: function fromQuaternion(q) {
      Mat4Func.fromQuat(this, q);
      return this;
    }
  }, {
    key: "setPosition",
    value: function setPosition(v) {
      this.x = v[0];
      this.y = v[1];
      this.z = v[2];
      return this;
    }
  }, {
    key: "inverse",
    value: function inverse() {
      var m = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      Mat4Func.invert(this, m);
      return this;
    }
  }, {
    key: "compose",
    value: function compose(q, pos, scale) {
      Mat4Func.fromRotationTranslationScale(this, q, pos, scale);
      return this;
    }
  }, {
    key: "getRotation",
    value: function getRotation(q) {
      Mat4Func.getRotation(q, this);
      return this;
    }
  }, {
    key: "getTranslation",
    value: function getTranslation(pos) {
      Mat4Func.getTranslation(pos, this);
      return this;
    }
  }, {
    key: "getScaling",
    value: function getScaling(scale) {
      Mat4Func.getScaling(scale, this);
      return this;
    }
  }, {
    key: "getMaxScaleOnAxis",
    value: function getMaxScaleOnAxis() {
      return Mat4Func.getMaxScaleOnAxis(this);
    }
  }, {
    key: "lookAt",
    value: function lookAt(eye, target, up) {
      Mat4Func.targetTo(this, eye, target, up);
      return this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      return Mat4Func.determinant(this);
    }
  }]);

  return Mat4;
}( /*#__PURE__*/_wrapNativeSuper(Array));